/**************************************************
 * Nombre:       Detalle_Tour
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {ArrowBackIos, FiberManualRecord, WhatsApp} from '@mui/icons-material'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {formatoMoneda} from "../../../Utilidades/formatoMoneda";
import {irUrl} from "../../../Utilidades/irUrl";
import {useBotonWass} from "../../../Modulo_Boton_Wass/Hooks/useBotonWass";
import {irAtras} from "../../../Utilidades/irAtras";


const Detalle_Tour = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const {abrir, Vista} = useBotonWass()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Vista/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 10}}
                      sx={{justifyContent: 'flex-start', mt: sCell ? 14 : 20}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? -2 : -6, ml: sCell ? -4 : -16}}>
                            <Button
                                onClick={() => irAtras()}
                                variant={'text'} startIcon={<ArrowBackIos/>}>Atras</Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? -3 : -4}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <img src={item.img} width={'100%'} height={'auto'} style={{borderRadius: 20}}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', px: sCell ? 0 : 2}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Typography sx={{
                                                color: theme.palette.primary.main,
                                                fontSize: 18,
                                                fontWeight: 400
                                            }}>Precio</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: -1}}>
                                            <Typography sx={{
                                                fontSize: 32,
                                                fontWeight: 800
                                            }}>{formatoMoneda(item.valor)}</Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 1}}>
                                            <Grid
                                                container
                                                justifyContent={'flex-start'}
                                                alignItems={'flex-start'}
                                                size={{xs: 12, sm: 12, md: 12}}
                                                spacing={2}
                                            >

                                                <Button
                                                    onClick={(e) => abrir(e.target)}
                                                    fullWidth={sCell} startIcon={<WhatsApp/>}
                                                    sx={{px: 6}}>Reservar</Button>

                                                {item.linkVideo &&
                                                    <Button
                                                        onClick={() => irUrl(item.linkVideo)}
                                                        variant={'outlined'} sx={{px: 6}}>Ver Video</Button>
                                                }

                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{
                                        fontSize: !masSM ? 32 : 40,
                                        fontWeight: 800,
                                        color: theme.palette.primary.main,
                                        lineHeight: 1.1
                                    }}>
                                        {item.nombre}</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 400}}>
                                        {item.descripcion}
                                    </Typography>
                                </Grid>

                                {item && item.espeficiaciones && item.espeficiaciones.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: -2}}>
                                            <Typography sx={{fontWeight: 400, fontSize: 14}}>
                                        <span><FiberManualRecord sx={{
                                            mt: 0.5,
                                            mb: -0.5,
                                            width: 18,
                                            height: 18,
                                            fill: theme.palette.primary.main
                                        }}/></span>
                                                <span style={{fontWeight: 600, paddingLeft: 4}}>{it.nombre}: </span>
                                                {it.descripcion}
                                            </Typography>
                                        </Grid>

                                    )
                                })}


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 600}}>Incluye</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        {item.incluidos && item.incluidos.map((it, index) => {
                                            return (
                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <Typography sx={{fontWeight: 300, fontSize: 15}}>
                                        <span><FiberManualRecord sx={{
                                            mt: 0.4,
                                            mb: -0.4,
                                            width: 16,
                                            height: 16,
                                            fill: theme.palette.primary.main,
                                            pr: 0.5
                                        }}/></span>
                                                        {it}</Typography>
                                                </Grid>
                                            )
                                        })}

                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 600}}>No Incluye</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        {item.noincluidos && item.noincluidos.map((it, index) => {
                                            return (
                                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                      sx={{justifyContent: 'flex-start'}}>
                                                    <Typography sx={{fontWeight: 300, fontSize: 15}}>
                                        <span><FiberManualRecord sx={{
                                            mt: 0.4,
                                            mb: -0.4,
                                            width: 16,
                                            height: 16,
                                            fill: '#00000080',
                                            pr: 0.5
                                        }}/></span>
                                                        {it}</Typography>
                                                </Grid>
                                            )
                                        })}

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Tour

const items = [1, 2, 3]

